// extracted by mini-css-extract-plugin
module.exports = {"title":"_5a28450529--title--Qndyz","title-tablet":"_5a28450529--title-tablet--m6qFE","title-phone":"_5a28450529--title-phone--ctcGY"};